export const SUPPLEMENT_GROUPS = [
  { id: 1, name: "Matérias-Primas" },
  { id: 2, name: "Suplementos & Concentrados" },
  { id: 3, name: "Rações" },
];

export const SUPPLEMENT_SUB_GROUPS = [
  { id: 1, name: "Forragens Verdes", supplement_group_id: 1 },
  { id: 2, name: "Forragens Secas", supplement_group_id: 1 },
  { id: 3, name: "Resíduos Agrícolas", supplement_group_id: 1 },
  { id: 4, name: "Proteicos", supplement_group_id: 1 },
  { id: 5, name: "Energéticos", supplement_group_id: 1 },
  { id: 6, name: "Minerais", supplement_group_id: 1 },
  { id: 7, name: "S&C Prot/Energ", supplement_group_id: 2 },
  { id: 8, name: "S&C Prot/Energ/Minerais", supplement_group_id: 2 },
  { id: 9, name: "S Mineral", supplement_group_id: 2 },
  { id: 10, name: "S Ração", supplement_group_id: 3 },
];

export const SUPPLEMENT_PRESENTATION = [
  { id: 1, name: "Gramínea" },
  { id: 2, name: "Silagem" },
  { id: 3, name: "Feno" },
  { id: 4, name: "Resíduo / Subproduto" },
  { id: 5, name: "Concentrado Seco" },
  { id: 6, name: "Concentrado Úmido" },
];

export const VETERINARY_TYPES = [
  { key: "Vacina", name: "Vacina" },
  { key: "Vermífugo", name: "Vermífugo" },
  { key: "Medicamento", name: "Medicamento" },
];

export const VETERINARY_APPLICATION_GENDER_TYPES = [
  { key: "Male", name: "Macho" },
  { key: "Female", name: "Fêmea" },
  { key: "Both", name: "Ambos" },
];

export const VETERINARY_APPLICATION_TYPES = [
  { key: "Fixo", name: "Fixo" },
  { key: "PorPeso", name: "Por Peso" },
];
